module.exports = __webpack_public_path__ + "static/media/brothercito_sentado_escritorio.6617b22c.svg";